import React from 'react';
import styles from '../../styles/home.module.css';

function SectionOne() {
    return (
        <section className={styles.SectionOne}>
            <div className={styles.Background}>
            <img className={styles.Image} src={require('../../images/header2.png')} alt="Header" />
            
                <div className={styles.ColBack}>
                    <div className={styles.InBack}>
                    <p>Zdravnik, ki je vedno z vami</p>
                    </div>
                    <div className="">
                        <a className={styles.PicButton} href="#try">NAMESTI</a>
                    </div>
                </div>
            </div>
        </section>
    )
}
export default SectionOne;